export default __webpack_public_path__ + "static/media/01_Vardablur.89b45f0c.webp";